import { UserId } from '@business/entities/account';
import { Endpoint } from '../endpoint';
import { PTOUserResponse, TimeoffID, TimeoffResponse } from '@business/entities/pto';
import { CommonService } from '@business/services';
import { TimeOffFormData } from '@modules/timeoff/AddTimeOffModal/AddTimeOffModal';

export function fetchUsers() {
  return Endpoint.get<PTOUserResponse[]>(`@gc/timeoff/users`);
}

export function saveTimeoff(data: TimeOffFormData) {
  return Endpoint.post<TimeoffResponse>(`@gc/timeoff`, { data });
}

export function updateTimeoff(id: TimeoffID, data: TimeOffFormData) {
  return Endpoint.patch<TimeoffResponse>(`@gc/timeoff/${id}`, { data });
}

export function fetchUserTimeoffs(id: UserId) {
  return Endpoint.get<TimeoffResponse[]>(`@gc/timeoff/user-timeoff/${id}`, {});
}

export function deleteTimeoff(id: TimeoffID) {
  return Endpoint.delete<void>(`@gc/timeoff/${id}`);
}
